export function idgen() {
    return `${Math.random()}`.substring( 2 );
}


// WEBPACK FOOTER //
// ./src/js/utils/idgen.js